import { useQuery } from '@tanstack/react-query';
import type { UseQueryResult } from '@tanstack/react-query';

import { getUserReports } from 'api/generated/users/users';

import { getOktaUserId } from 'helpers/okta-session';

import type { UserReportDto } from 'api/market-view-api';

export const reportsKeys = {
  all: ['reports'] as const,
  list: () => [...reportsKeys.all, 'list'] as const,
};

export interface UseReportsResult {
  data: UserReportDto[] | null;
  loading: boolean;
  error: unknown;
}

export const useReports = (): UseReportsResult => {
  const oktaUserId = getOktaUserId() ?? '';

  const query: UseQueryResult<UserReportDto[], Error> = useQuery({
    queryKey: reportsKeys.list(),
    queryFn: async () => {
      const reports = await getUserReports(oktaUserId, { sort: {} });

      return reports as UserReportDto[];
    },
    enabled: !!oktaUserId,
  });

  return {
    data: query.data ?? null,
    loading: query.isLoading,
    error: query.error,
  };
};
